import React from "react";
import { formTypes } from "../../formTypes";
import Buttons from "../Buttons";
import "./styles.scss";

const MessageModal = ({ typeMessage, onClose }) => {
  const type = formTypes[typeMessage.type];
  const { msgEmail } = typeMessage;
  const hasButtons = Boolean(type?.btns?.length);
  return (
    <div className="message-content">
      <p>{msgEmail || type.text}</p>
      {hasButtons && <Buttons onClose={onClose} type={typeMessage.type} />}
    </div>
  );
};

export default MessageModal;
